(() => {
  // utils/common.js
  function poll(condition, callback, persistent = false, timeout = 1e4, pollInterval = 25) {
    if (condition()) {
      callback(condition());
    } else if (timeout > 0) {
      setTimeout(() => {
        poll(condition, callback, persistent, persistent ? timeout : timeout - pollInterval, pollInterval);
      }, pollInterval);
    }
  }
  function q(s, o) {
    return o ? s.querySelector(o) : document.querySelector(s);
  }
  function qq(s, o) {
    return o ? [...s.querySelectorAll(o)] : [...document.querySelectorAll(s)];
  }
  function insert(target, position, element, exists) {
    try {
      if (!exists) {
        typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
      }
    } catch (e) {
      console.debug(position, " :: ", element);
    }
  }
  var changeHTML = (elem, text) => {
    if (elem.innerHTML !== text) {
      elem.innerHTML = text;
    }
  };

  // src/Happybrush/HAP-2/1/info.js
  var ID = "HAP-2";
  var VAR = "1";
  function expLog() {
    window.runningExperiments[ID].logs.push([...arguments]);
  }

  // src/Happybrush/HAP-2/1/index.js
  function testInfo(testName) {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
      name: testName || "",
      variation: `${VAR}`,
      logs: []
    };
    poll(
      () => q("body"),
      () => {
        q("body").classList.add(`${ID}`, `${ID}_${VAR}`);
      }
    );
  }
  var recommendedProducts = {
    "austausch-schallzahnburste-eco-vibe-lite-HBV3EST4T": {
      SKU: "HBV3EST4T",
      associated_product: "aufsteckbuersten-eco-vibe-3-sunrise"
    },
    "sommer-set-eco-vibe-lite-BV3EST4TSMR": {
      SKU: "BV3EST4TSMR",
      associated_product: "eco-flow-aufsteckdusen-3x"
    },
    "sommer-set-eco-vibe-3-BV3DEABSMR": {
      SKU: "BV3DEABSMR",
      associated_product: "eco-flow-aufsteckdusen-3x"
    },
    "schallzahnburste-eco-vibe-lite-twenty4tim-edition-BV3EST4TE": {
      SKU: "BV3EST4TE",
      associated_product: "aufsteckbuersten-eco-vibe-3-sunrise"
    },
    "schallzahnburste-eco-vibe-lite-twenty4tim-edition-BV3EST4TZP": {
      SKU: "BV3EST4TZP",
      associated_product: "aufsteckbuersten-eco-vibe-3-sunrise"
    },
    "schallzahnburste-eco-vibe-lite-twenty4tim-edition-BV3EST4TL": {
      SKU: "BV3EST4TL",
      associated_product: "aufsteckbuersten-eco-vibe-3-sunrise"
    },
    "schallzahnbuerste-ocean-shower-kit-gotbag-BV3OGB": {
      SKU: "BV3OGB",
      associated_product: "aufsteckbursten-eco-vibe-3-ocean"
    },
    "eco-vibe-3-whitening-set-sunrise-BV3SVCCRF": {
      SKU: "BV3SVCCRF",
      associated_product: "eco-vibe-3-whitening-set-black-mint"
    },
    "eco-vibe-3-set-s-agnes-BV3AE": {
      SKU: "BV3AE",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "eco-vibe-3-whitening-set-white-mint-BV3WCCRF": {
      SKU: "BV3WCCRF",
      associated_product: "aktivkohle-white-zahnpasta"
    },
    "eletrische-zahnbuerste-v3-whitemint-kauflandcard-KLCDL01": {
      SKU: "KLCDL01",
      associated_product: "aufsteckbursten-eco-vibe-3-white-mint"
    },
    "brush4water-zahnpasta-pramie-REWHZ02BW": {
      SKU: "REWHZ02BW",
      associated_product: "schallzahnbuerste-eco-vibe-3-set-m"
    },
    "colour-corrector-HZ02CC": {
      SKU: "HZ02CC",
      associated_product: "eco-vibe-3-whitening-set-white-mint"
    },
    "kinderzahnburste-agnes-sensimed-by-happybrush-HZB2SA2": {
      SKU: "HZB2SA2",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-agnes-HZB2A-V": {
      SKU: "HZB2A-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-agnes-HZB2A2-V": {
      SKU: "HZB2A2-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-agnes-HZB2A4-V": {
      SKU: "HZB2A4-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-sesamstrasse-HZB2S-V": {
      SKU: "HZB2S-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-sesamstrasse-HZB2S2-V": {
      SKU: "HZB2S2-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-sesamstrasse-HZB2S4-V": {
      SKU: "HZB2S4-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-minions-HZB2M-V": {
      SKU: "HZB2M-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-minions-HZB2M2-V": {
      SKU: "HZB2M2-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bambus-zahnburste-minions-HZB2M4-V": {
      SKU: "HZB2M4-V",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "superkids-kinderzahnpasta-HZ02SK2-V": {
      SKU: "HZ02SK2-V",
      associated_product: "eco-vibe-3-set-agnes"
    },
    "superkids-kinderzahnpasta-HZ02SK5-V": {
      SKU: "HZ02SK5-V",
      associated_product: "eco-vibe-3-set-agnes"
    },
    "superkids-kinderzahnpasta-HZ02SK7-V": {
      SKU: "HZ02SK7-V",
      associated_product: "eco-vibe-3-set-agnes"
    },
    "supercolor-kinderzahnpasta-HZ02A2-V": {
      SKU: "HZ02A2-V",
      associated_product: "eco-vibe-3-set-agnes"
    },
    "supercolor-kinderzahnpasta-HZ02A5-V": {
      SKU: "HZ02A5-V",
      associated_product: "eco-vibe-3-set-agnes"
    },
    "supercolor-kinderzahnpasta-HZ02A7-V": {
      SKU: "HZ02A7-V",
      associated_product: "eco-vibe-3-set-agnes"
    },
    "brush-for-water-zahnpasta-HZ02BW2-V": {
      SKU: "HZ02BW2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "brush-for-water-zahnpasta-HZ02BW5-V": {
      SKU: "HZ02BW5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "brush-for-water-zahnpasta-HZ02BW7-V": {
      SKU: "HZ02BW7-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superprotect-zahnpasta-HZ02P2-V": {
      SKU: "HZ02P2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superprotect-zahnpasta-HZ02P5-V": {
      SKU: "HZ02P5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superprotect-zahnpasta-HZ02P7-V": {
      SKU: "HZ02P7-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "repair-care-zahnpasta-HZ02RC2-V": {
      SKU: "HZ02RC2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "repair-care-zahnpasta-HZ02RC5-V": {
      SKU: "HZ02RC5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "repair-care-zahnpasta-HZ02RC7-V": {
      SKU: "HZ02RC7-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "aktivkohle-white-zahnpasta-HZ02CW2-V": {
      SKU: "HZ02CW2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "aktivkohle-white-zahnpasta-HZ02CW5-V": {
      SKU: "HZ02CW5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "aktivkohle-white-zahnpasta-HZ02CW7-V": {
      SKU: "HZ02CW7-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "aufsteckbuersten-eco-r2-allblack-HAR2AB-V2": {
      SKU: "HAR2AB-V2",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-r2-allblack-HAR2AB6-V": {
      SKU: "HAR2AB6-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-r2-allblack-HAR2AB9-V": {
      SKU: "HAR2AB9-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-sunrise-HAV3DESV-V2": {
      SKU: "HAV3DESV-V2",
      associated_product: "twenty4tim-zahnpasta-set"
    },
    "aufsteckbuersten-eco-vibe-3-sunrise-HAV3DESV6-V": {
      SKU: "HAV3DESV6-V",
      associated_product: "twenty4tim-zahnpasta-set"
    },
    "aufsteckbuersten-eco-vibe-3-sunrise-HAV3DESV9-V": {
      SKU: "HAV3DESV9-V",
      associated_product: "twenty4tim-zahnpasta-set"
    },
    "aufsteckbursten-eco-vibe-3-ocean-HAV3DEO-V2": {
      SKU: "HAV3DEO-V2",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-ocean-HAV3O6-V": {
      SKU: "HAV3O6-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-ocean-HAV3O9-V": {
      SKU: "HAV3O9-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-white-mint-HAV3DEW-V2": {
      SKU: "HAV3DEW-V2",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-white-mint-HAV3W6-V": {
      SKU: "HAV3W6-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-white-mint-HAV3W9-V": {
      SKU: "HAV3W9-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-white-mint-HAV3DESW3": {
      SKU: "HAV3DESW3",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-white-mint-HAV3DESW6": {
      SKU: "HAV3DESW6",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-white-mint-HAV3DESW9": {
      SKU: "HAV3DESW9",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-allblack-HAV3DEAB-V2": {
      SKU: "HAV3DEAB-V2",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-allblack-HAV3AB6-V": {
      SKU: "HAV3AB6-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-allblack-HAV3AB9-V": {
      SKU: "HAV3AB9-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-black-mint-HAV3DES-V2": {
      SKU: "HAV3DES-V2",
      associated_product: "probierset-zahnpasta-klein"
    },
    "auf NOTRUNCATE steckbursten-eco-vibe-3-black-mint-HAV3S6-V": {
      SKU: "HAV3S6-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-black-mint-HAV3S9-V": {
      SKU: "HAV3S9-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-black-mint-HAV3DESS3": {
      SKU: "HAV3DESS3",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-black-mint-HAV3DESS6": {
      SKU: "HAV3DESS6",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbuersten-eco-vibe-3-black-mint-HAV3DESS9": {
      SKU: "HAV3DESS9",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-bambus-HAV3BB-V2": {
      SKU: "HAV3BB-V2",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-bambus-HAV3BB6-V": {
      SKU: "HAV3BB6-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "aufsteckbursten-eco-vibe-3-bambus-HAV3BB9-V": {
      SKU: "HAV3BB9-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "schallzahnbuerste-eco-vibe-3-set-s-BV3DEABE": {
      SKU: "BV3DEABE",
      associated_product: "travelcase-allblack"
    },
    "schallzahnbuerste-eco-vibe-3-set-s-BV3SE-V": {
      SKU: "BV3SE-V",
      associated_product: "travelcase-allblack"
    },
    "schallzahnbuerste-eco-vibe-3-set-s-BV3WE-V": {
      SKU: "BV3WE-V",
      associated_product: "travelcase-allblack"
    },
    "schallzahnbuerste-eco-vibe-3-set-s-BV3SVE-V": {
      SKU: "BV3SVE-V",
      associated_product: "travelcase-allblack"
    },
    "schallzahnbuerste-eco-vibe-3-set-s-BV3OE-V": {
      SKU: "BV3OE-V",
      associated_product: "travelcase-allblack"
    },
    "schallzahnbuerste-eco-vibe-3-set-m-BV3DEABZPTC": {
      SKU: "BV3DEABZPTC",
      associated_product: "probierset-zahnpasta-klein"
    },
    "schallzahnbuerste-eco-vibe-3-set-m-BV3SZPTC-V": {
      SKU: "BV3SZPTC-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "schallzahnbuerste-eco-vibe-3-set-m-BV3WZPTC-V": {
      SKU: "BV3WZPTC-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "schallzahnbuerste-eco-vibe-3-set-m-BV3OZPTC-V": {
      SKU: "BV3OZPTC-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "schallzahnbuerste-eco-vibe-3-set-m-BV3SVRF-V": {
      SKU: "BV3SVRF-V",
      associated_product: "probierset-zahnpasta-klein"
    },
    "schallzahnbuerste-eco-vibe-3-set-l-BV3DEABM": {
      SKU: "BV3DEABM",
      associated_product: "eco-flow-munddusche"
    },
    "schallzahnbuerste-eco-vibe-3-set-l-BV3SM-V": {
      SKU: "BV3SM-V",
      associated_product: "eco-flow-munddusche"
    },
    "schallzahnbuerste-eco-vibe-3-set-l-BV3WM-V": {
      SKU: "BV3WM-V",
      associated_product: "eco-flow-munddusche"
    },
    "schallzahnbuerste-eco-vibe-3-set-l-BV3SVM-V": {
      SKU: "BV3SVM-V",
      associated_product: "eco-flow-munddusche"
    },
    "schallzahnbuerste-eco-vibe-3-set-l-BV3OM-V": {
      SKU: "BV3OM-V",
      associated_product: "eco-flow-munddusche"
    },
    "schallzahnbuerste-eco-vibe-3-set-xl-BV3DEABL": {
      SKU: "BV3DEABL",
      associated_product: "eco-flow-munddusche-set"
    },
    "schallzahnbuerste-eco-vibe-3-set-xl-BV3SL-V": {
      SKU: "BV3SL-V",
      associated_product: "eco-flow-munddusche-set"
    },
    "schallzahnbuerste-eco-vibe-3-set-xl-BV3WL-V": {
      SKU: "BV3WL-V",
      associated_product: "eco-flow-munddusche-set"
    },
    "schallzahnbuerste-eco-vibe-3-set-xl-BV3OL-V": {
      SKU: "BV3OL-V",
      associated_product: "eco-flow-munddusche-set"
    },
    "schallzahnbuerste-eco-vibe-3-set-xl-BV3SVL-V": {
      SKU: "BV3SVL-V",
      associated_product: "eco-flow-munddusche-set"
    },
    "eco-flow-munddusche-BMD01E": {
      SKU: "BMD01E",
      associated_product: "eco-flow-aufsteckdusen-3x"
    },
    "eco-flow-munddusche-set-BHMD01": {
      SKU: "BHMD01",
      associated_product: "eco-flow-aufsteckdusen-3x"
    },
    "eco-flow-eco-vibe-3-set-BHMD01V3": {
      SKU: "BHMD01V3",
      associated_product: "eco-flow-aufsteckdusen-3x"
    },
    "superwhite-sensitive-whitening-zahnpasta-HZ02W2-V": {
      SKU: "HZ02W2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superwhite-sensitive-whitening-zahnpasta-HZ02WP5-V": {
      SKU: "HZ02WP5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superwhite-sensitive-whitening-zahnpasta-HZ02WP7-V": {
      SKU: "HZ02WP7-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superblack-zahnpasta-HZ02B2-V": {
      SKU: "HZ02B2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superblack-zahnpasta-HZ02B5-V": {
      SKU: "HZ02B5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "superblack-zahnpasta-HZ02B7V-V": {
      SKU: "HZ02B7V-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "sensimed-sensitive-care-zahnpasta-HZ03SC2-V": {
      SKU: "HZ03SC2-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "sensimed-sensitive-care-zahnpasta-HZ03SC5-V": {
      SKU: "HZ03SC5-V",
      associated_product: "superclean-mundspulung-2er"
    },
    "austausch-artikel-eco-vibe-3-HBV3DEAB": {
      SKU: "HBV3DEAB",
      associated_product: "probierset-zahnpasta-klein"
    },
    "eco-flow-aufsteckdusen-3x-HMD01RF": {
      SKU: "HMD01RF",
      associated_product: "eco-flow-eco-vibe-3-set"
    },
    "eco-flow-munddusche-austauschprodukt-HMD01": {
      SKU: "HMD01",
      associated_product: "eco-flow-aufsteckdusen-3x"
    },
    "handstuck-vibe-3-allblack-HBV3AB1": {
      SKU: "HBV3AB1",
      associated_product: "aufsteckbuersten-eco-vibe-3-allblack"
    },
    "dental-pod-zahnschienen-reiniger-DPZ01B": {
      SKU: "DPZ01B",
      associated_product: "bundle-daily-fresh-set"
    },
    "dental-pod-zahnschienen-reiniger-DPZ01W": {
      SKU: "DPZ01W",
      associated_product: "bundle-daily-fresh-set"
    },
    "handstuck-vibe-3-ocean-HBV3O1": {
      SKU: "HBV3O1",
      associated_product: "aufsteckbursten-eco-vibe-3-ocean"
    },
    "ecochange-zahnburste-mint-HBES02": {
      SKU: "HBES02",
      associated_product: "probierset-zahnpasta-klein"
    },
    "superclean-zahnseide-nachfullpack-HBZS01RF": {
      SKU: "HBZS01RF",
      associated_product: "eco-flow-munddusche-set"
    },
    "refill-set-superclean-zahnseide-nachfullpack-BZS01RF": {
      SKU: "BZS01RF",
      associated_product: "eco-flow-munddusche-set"
    },
    "twenty4tim-zahnpasta-set-BZPT4T": {
      SKU: "BZPT4T",
      associated_product: "twenty4tim-eco-change-set"
    },
    "twenty4tim-eco-change-set-BEST4T": {
      SKU: "BEST4T",
      associated_product: "schallzahnburste-eco-vibe-lite-twenty4tim-edition"
    },
    "1x-handle-1x-aufsteckburste-HBV3SV": {
      SKU: "HBV3SV",
      associated_product: "aufsteckbuersten-eco-vibe-3-sunrise"
    },
    "influencer-set-sunrise-BV3SV-IN": {
      SKU: "BV3SV-IN",
      associated_product: "twenty4tim-zahnpasta-set"
    },
    "influencer-set-ocean-BV3O-IN": {
      SKU: "BV3O-IN",
      associated_product: "twenty4tim-zahnpasta-set"
    },
    "influencer-bundle-allblack-BV3DEAB-IN": {
      SKU: "BV3DEAB-IN",
      associated_product: "twenty4tim-zahnpasta-set"
    },
    "austausch-eco-vibe-3-agnes-HBV3A": {
      SKU: "HBV3A",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "eco-vibe-3-agnes-HAV3DEA": {
      SKU: "HAV3DEA",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "eco-vibe-3-set-agnes-BXA02": {
      SKU: "BXA02",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "ecovibe-kids-HBPAW01": {
      SKU: "HBPAW01",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "bundle-zahnpasta-nachfullbeutel-2er-pack-BZRF2": {
      SKU: "BZRF2",
      associated_product: "superclean-mundspulung-2er"
    },
    "bundle-zahnpasta-spender-nachfullbeutel-BZRF01": {
      SKU: "BZRF01",
      associated_product: "superclean-mundspulung-2er"
    },
    "aufsteckbursten-eco-vibe-kids-paw-patrol-HAPAW01": {
      SKU: "HAPAW01",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "eco-vibe-kids-paw-patrol-bundle-BBP01AP01": {
      SKU: "BBP01AP01",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "r2-allblack-1-BR2ABE": {
      SKU: "BR2ABE",
      associated_product: "aufsteckbuersten-eco-r2-allblack"
    },
    "akkutausch-eco-vibe-3-HBAT": {
      SKU: "HBAT",
      associated_product: "bundle-daily-fresh-set"
    },
    "ecochange-refills-3er-HAES01": {
      SKU: "HAES01",
      associated_product: "bundle-daily-fresh-set"
    },
    "ecochange-handzahnburste-HBES01": {
      SKU: "HBES01",
      associated_product: "bundle-daily-fresh-set"
    },
    "starterkit-r2-allblack-routierend-HBR2AB": {
      SKU: "HBR2AB",
      associated_product: "aufsteckbuersten-eco-r2-allblack"
    },
    "charger-starterkit-schall-v3-minion-LADHBV3MN": {
      SKU: "LADHBV3MN",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-starterkit-schall-v3-ocean-LADHBV3O": {
      SKU: "LADHBV3O",
      associated_product: "bundle-daily-fresh-set"
    },
    "bundle-superfresh-set-HBM2Z3B": {
      SKU: "HBM2Z3B",
      associated_product: "eco-v3-entdecker-set-white-mint"
    },
    "probierset-zahnpasta-mittel-HZ02MIX5B": {
      SKU: "HZ02MIX5B",
      associated_product: "superclean-mundspulung-2er"
    },
    "probierset-zahnpasta-gross-HZ02MIX7B": {
      SKU: "HZ02MIX7B",
      associated_product: "superclean-mundspulung-2er"
    },
    "r2-allblack-entdecker-set-BR2ABEAT01": {
      SKU: "BR2ABEAT01",
      associated_product: "aufsteckbuersten-eco-r2-allblack"
    },
    "bundle-r2-allblack-rf-bzp-travelcase-allblack-HBR2BAB": {
      SKU: "HBR2BAB",
      associated_product: "aufsteckbuersten-eco-r2-allblack"
    },
    "repaircare-zahnpasta-REWHZ02RC": {
      SKU: "REWHZ02RC",
      associated_product: "bundle-daily-fresh-set"
    },
    "bundle-daily-fresh-set-HBMP04": {
      SKU: "HBMP04",
      associated_product: "eco-v3-entdecker-set-white-mint"
    },
    "v3-allblack-bayerische-BAYRV3AB": {
      SKU: "BAYRV3AB",
      associated_product: "aufsteckbuersten-eco-vibe-3-allblack"
    },
    "charger-starterkit-schall-v3-allblack-LADHBV3AB": {
      SKU: "LADHBV3AB",
      associated_product: "bundle-daily-fresh-set"
    },
    "ecovibe-3-ocean-austausch-HBV3O": {
      SKU: "HBV3O",
      associated_product: "aufsteckbursten-eco-vibe-3-ocean"
    },
    "probierset-zahnpasta-klein-HZ02MIX3": {
      SKU: "HZ02MIX3",
      associated_product: "superclean-mundspulung-2er"
    },
    "refurbished-starterkit-v3-schwarz-mint-REPV3S": {
      SKU: "REPV3S",
      associated_product: "aufsteckbuersten-eco-vibe-3-black-mint"
    },
    "aufsteckbursten-rundkopf-3-rot-HAR02R": {
      SKU: "HAR02R",
      associated_product: "bundle-daily-fresh-set"
    },
    "travelcase-allblack-HZUB07": {
      SKU: "HZUB07",
      associated_product: "bundle-daily-fresh-set"
    },
    "eco-aufsteckbursten-schall-v3-3er-minions-HAV3MN": {
      SKU: "HAV3MN",
      associated_product: "supercolor-kinderzahnpasta"
    },
    "aufsteckbursten-rotierend-3er-blau-HAR2B3": {
      SKU: "HAR2B3",
      associated_product: "bundle-daily-fresh-set"
    },
    "superclean-interdentalbursten-iso-3-HBIB32P": {
      SKU: "HBIB32P",
      associated_product: "eco-flow-munddusche-set"
    },
    "superclean-interdentalbursten-iso-2-HBIB22P": {
      SKU: "HBIB22P",
      associated_product: "eco-flow-munddusche-set"
    },
    "superclean-interdentalbursten-iso-1-HBIB12P": {
      SKU: "HBIB12P",
      associated_product: "eco-flow-munddusche-set"
    },
    "superclean-interdentalbursten-iso-0-HBIB02P": {
      SKU: "HBIB02P",
      associated_product: "eco-flow-munddusche-set"
    },
    "handstuck-schall-v3-schwarz-HBV3S1": {
      SKU: "HBV3S1",
      associated_product: "aufsteckbuersten-eco-vibe-3-black-mint"
    },
    "handstuck-schall-v3-weiss-HBV3W1": {
      SKU: "HBV3W1",
      associated_product: "aufsteckbursten-eco-vibe-3-white-mint"
    },
    "superclean-zahnseide-HBZSB2": {
      SKU: "HBZSB2",
      associated_product: "eco-flow-munddusche-set"
    },
    "happybrush-zahnseide-HBZS01": {
      SKU: "HBZS01",
      associated_product: "eco-flow-munddusche-set"
    },
    "aufsteckbursten-schall-v1-3er-weiss-HAV1W": {
      SKU: "HAV1W",
      associated_product: "bundle-daily-fresh-set"
    },
    "aufsteckbursten-schall-v1-3er-schwarz-HAV1S": {
      SKU: "HAV1S",
      associated_product: "bundle-daily-fresh-set"
    },
    "superclean-mundspulung-2er-HBMC2P": {
      SKU: "HBMC2P",
      associated_product: "eco-flow-munddusche-set"
    },
    "starterkit-schall-v3-partner-bundle-schwarz-weiss-HBV3BSW": {
      SKU: "HBV3BSW",
      associated_product: "eco-flow-munddusche-set"
    },
    "cube-aufsteckbursten-halter-HBZUB04": {
      SKU: "HBZUB04",
      associated_product: "bundle-daily-fresh-set"
    },
    "travelcase-HZUB02": {
      SKU: "HZUB02",
      associated_product: "bundle-daily-fresh-set"
    },
    "aufsteckbursten-rundkopf-r2-3er-weiss-HAR02W": {
      SKU: "HAR02W",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-starterkit-schall-v3-weiss-LADHBV3W": {
      SKU: "LADHBV3W",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-starterkit-schall-v3-schwarz-LADHBV3S": {
      SKU: "LADHBV3S",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-starterkit-schall-v2-pink-LADHBV2P": {
      SKU: "LADHBV2P",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-starterkit-schall-v2-weiss-LADHBV2W": {
      SKU: "LADHBV2W",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-schall-v1-mint-LADHBV1M": {
      SKU: "LADHBV1M",
      associated_product: "bundle-daily-fresh-set"
    },
    "charger-schall-v1-weiss-LADHBV1W": {
      SKU: "LADHBV1W",
      associated_product: "bundle-daily-fresh-set"
    },
    "aufsteckbursten-schall-vibe-2-3er-schwarz-HAV2S": {
      SKU: "HAV2S",
      associated_product: "bundle-daily-fresh-set"
    },
    "aufsteckbursten-schall-vibe-2-3er-mint-HAV2M": {
      SKU: "HAV2M",
      associated_product: "bundle-daily-fresh-set"
    },
    "aufsteckbursten-schall-vibe-2-3er-weiss-HAV2W": {
      SKU: "HAV2W",
      associated_product: "bundle-daily-fresh-set"
    },
    "starterkit-schall-vibe-3-weiss-HBV3W": {
      SKU: "HBV3W",
      associated_product: "aufsteckbursten-eco-vibe-3-white-mint"
    },
    "starterkit-schall-vibe-3-schwarz-HBV3S": {
      SKU: "HBV3S",
      associated_product: "aufsteckbuersten-eco-vibe-3-black-mint"
    }
  };
  function getGiftState() {
    const firstActive = q(".gift-product-1-cart.gift-product-comman-class.buy-active");
    const secondActive = q(".gift-product-2-cart.gift-product-comman-class.buy-active");
    if (secondActive) return "second";
    if (firstActive) return "first";
    return "none";
  }
  function changeMiniCart() {
    expLog("changeMiniCart");
    poll(
      () => q("mini-shipping-estimator .totals__subtotal") && q(
        "mini-shipping-estimator .totals__subtotal-value.country__shipping-value"
      ) && q(".ed-store-benefits-cart .store-benefit-item.first-store-benefit") && q(".gift-function-wrap-ouer-main") && q("cart-drawer .drawer__content"),
      () => {
        q("cart-drawer .drawer__content").classList.add(
          `${ID}-mini-cart-container`
        );
        // Do not overwrite totals__subtotal: keep theme delivery text (cart_delivery_time_text from theme settings) so it stays consistent (e.g. "in 3-4 Werktagen bei dir") and does not change to "in 1-2 Tagen bei dir" when cart is full.
        const freeShippingLabelEl = q("mini-shipping-estimator .free-shipping-label");
        if (freeShippingLabelEl) {
          const state = getGiftState();
          if (state === "second") {
            const text = `<span class="${ID}-free-shipping-label">KOSTENLOS</span>`;
            changeHTML(freeShippingLabelEl, text);
          } else if (state === "first") {
            const themeText = freeShippingLabelEl.textContent?.trim();
            if (!themeText || themeText.length === 0) {
              const text = `<span class="${ID}-free-shipping-label-intermediate">Glückwunsch! Du hast dein erstes Geschenk freigeschaltet 🎁</span>`;
              changeHTML(freeShippingLabelEl, text);
            }
          }
        }
        const storeBenefits = `
      <div class="${ID}-store-benefit-item">
           <div class="${ID}-store-benefit-icon icon_size">
                <img src="https://assets.ablyft.com/64599163/dhzUsFLvmRrPMpB7dcfGgWbRC7BsVX2yVb7jvpcc.webp" data-widths="[20,30,40]" data-aspectratio="" data-sizes="auto" alt="">
           </div>
           <div class="store-benefit-texte block_font_size">
                5 Mio+ lieben uns 
           </div>
      </div>
      `;
        insert(
          q(".ed-store-benefits-cart .store-benefit-item.first-store-benefit"),
          "afterend",
          storeBenefits,
          q(`.${ID}-store-benefit-item`)
        );
        expLog("mini-cart changed finished");
        const giftMarkup = `
       <div class="${ID}-gift-text-container">
          <p class="${ID}-gift-text">Du hast dein Geschenk freigeschaltet</p>
       </div>
       `;
        insert(
          q(".gift-function-wrap-ouer-main"),
          "beforebegin",
          giftMarkup,
          q(`.${ID}-gift-text-container`)
        );
      }
    );
  }
  function changeGiftCart() {
    poll(
      () => {
        const container = q(
          ".gift-product-1-cart.gift-product-comman-class.buy-active .right-side-gift-data"
        );
        if (!container) return false;
        // Wait until the value text is actually populated (non-empty string).
        const valueText = container.querySelector(".gift-cart-text-value")?.textContent?.trim();
        return (container && valueText && valueText.length > 0) ? container : false;
      },
      (container) => {
        if (!container) return;
        const currentTitle = container.querySelector(".gift-cart-text-title")?.textContent?.trim() || "Geschenk 1:";
        const currentValue = container.querySelector(".gift-cart-text-value")?.textContent?.trim() || "";
        const markup = `
      <div class="${ID}-gift-cart-text-container">
        <p class="${ID}-gift-cart-text-title">${currentTitle}</p>
        <p class="${ID}-gift-cart-text-value">${currentValue}</p>
      </div>
      `;
        changeHTML(container, markup);
      },
      false,
      30000 // extended timeout to allow for slow theme hydration
    );
  }
  function textContainerActive() {
    poll(
      () => q(`.${ID}-gift-text-container`) && q(".gift-product-1-cart.gift-product-comman-class"),
      () => {
        if (q(".gift-product-1-cart.gift-product-comman-class").classList.contains(
          "buy-active"
        )) {
          q(`.${ID}-gift-text-container`).classList.add("buy-active");
        } else {
          q(`.${ID}-gift-text-container`).classList.remove("buy-active");
        }
      }
    );
  }
  function addRecommendedProductsMarkup(data, SKU) {
    poll(
      () => q("cart-drawer-recommendations"),
      () => {
        const price = data.product.variants[0].price.replace(".", ",");
        let markup = `
    <div class="${ID}-recommended-products-container" data-main-product-sku="${SKU}" data-associated-product-sku="${data.product.variants[0].sku}">
    <div class="${ID}-recommended-products-title-container">
      <p class="${ID}-recommended-products-title-text">Kunden lieben diese Kombination</p>
      </div>
      <div class="${ID}-recommended-products-item">
        <div class="${ID}-recommended-products-item-image">
          <img src="${data.product.image.src}" alt="${data.product.title}">
        </div>
        <div class="${ID}-recommended-products-item-title">
          <p class="${ID}-recommended-products-item-title-text">${data.product.title}</p>
          <div class="${ID}-recommended-products-item-price">
            <p class="${ID}-recommended-products-item-price-text">${data.product.variants[0].price} € </p>
            <div class="${ID}-recommended-products-item-add-to-cart-button-form">
              <form method="post" action="/cart/add" 
              id="product_form_mini-cart_1_11572421951756_0" 
              accept-charset="UTF-8" 
              class="shopify-product-form" 
              enctype="multipart/form-data" is="product-form">
              <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="quantity" value="1" mm-min="1" mm-stock-max="NaN" step="1" mm-step="1">
                      <input type="hidden" name="id" value="${data.product.variants[0].id}">
                      <button type="submit" class="${ID}-recommended-products-item-add-to-cart-button" fdprocessedid="nsbupv">
                      </button>
                      <input type="hidden" name="product-id" value="${data.product.id}">
                      <input type="hidden" name="section-id" value="mini-cart">
              </form>
            </div>
          </div>
          <div class="${ID}-recommended-products-item-tag-container">
          <p class="${ID}-recommended-products-item-tag">Zur Bestellung hinzufügen : ${price} €</p>
          </div>
        </div>
    </div>
    `;
        insert(
          q("cart-drawer-recommendations"),
          "beforebegin",
          markup,
          q(`.${ID}-recommended-products-container`)
        );
      }
    );
  }
  function updateChangeCartTag() {
    poll(
      () => q(`.${ID}-recommended-products-item-tag-container`),
      () => {
        const markup = `
       <p class="${ID}-recommended-products-item-tag-active">hinzugefügt</p>
      `;
        const tagContainer = q(`.${ID}-recommended-products-item-tag-container`);
        tagContainer?.classList.add("active");
        changeHTML(q(`.${ID}-recommended-products-item-tag-container`), markup);
      }
    );
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest(`.${ID}-recommended-products-item-add-to-cart-button.active`)) {
      expLog("=======e==============", e);
      e.preventDefault();
      e.stopPropagation();
      const tagContainer = e.target.closest(`.${ID}-recommended-products-item-add-to-cart-button.active`);
      const associatedProductVariantId = tagContainer?.closest(`.${ID}-recommended-products-container`)?.dataset?.associatedProductSku;
      expLog("=======associatedProductVariantId==============", associatedProductVariantId);
      const items = minMaxify.cart.items;
      const item = items.find((item2) => item2.sku === associatedProductVariantId);
      if (item) {
        expLog("=======item is in cart==============");
        expLog("=======e==============", e);
        e.preventDefault();
        e.stopPropagation();
        expLog("=======quantity.click()==============");
        fetch("https://www.happybrush.de/cart/update.js", {
          method: "POST",
          credentials: "include",
          mode: "cors",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            updates: {
              [`${item.id}`]: 0
            },
            sections: ["mini-cart"]
          })
        }).then((response) => {
          expLog("=======data==============", response);
          cartRefresh();
        }).catch((error) => {
          expLog("=======error==============", error);
        });
      }
    }
  });
  function removeOnlyUpsellProduct() {
    poll(
      () => q(`.${ID}-recommended-products-item-add-to-cart-button.active`),
      () => {
        const tagContainer = q(`.${ID}-recommended-products-item-add-to-cart-button.active`);
        expLog("=======tagContainer==============", tagContainer);
        const associatedProductVariantId = tagContainer?.closest(`.${ID}-recommended-products-container`)?.dataset?.associatedProductSku;
        expLog("=======associatedProductVariantId==============", associatedProductVariantId);
        const items = minMaxify.cart.items;
        const item = items.find((item2) => item2.sku === associatedProductVariantId);
        expLog("=======item==============", item.id);
        if (item) {
          expLog("=======item is in cart==============");
          tagContainer.addEventListener("click", (e) => {
            expLog("=======e==============", e);
            e.preventDefault();
            e.stopPropagation();
            expLog("=======quantity.click()==============");
            fetch("https://www.happybrush.de/cart/update.js", {
              method: "POST",
              credentials: "include",
              mode: "cors",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates: {
                  [`${item.id}`]: 0
                },
                sections: ["mini-cart"]
              })
            }).then((response) => {
              expLog("=======data==============", response);
              cartRefresh();
            }).catch((error) => {
              expLog("=======error==============", error);
            });
          });
        }
      }
    );
  }
  function addRecommendedProductsToCart() {
    poll(
      () => q(`.${ID}-recommended-products-container`) && q(`.${ID}-recommended-products-item-add-to-cart-button`),
      () => {
        document.addEventListener("click", (e) => {
          if (e.target.closest(
            `.${ID}-recommended-products-item-add-to-cart-button`
          )) {
            const items = minMaxify.cart.items;
            const mainProductSku = q(`.${ID}-recommended-products-container`).dataset.mainProductSku;
            const mainProduct = items.find((item2) => item2.sku === mainProductSku);
            const associatedProductSku = q(`.${ID}-recommended-products-container`).dataset.associatedProductSku;
            const item = items.find((item2) => item2.sku === associatedProductSku);
            if (item && mainProduct) {
              const button = e.target.closest(`.${ID}-recommended-products-item-add-to-cart-button`);
              button?.classList.add("active");
              updateChangeCartTag();
            }
          }
        });
      }
    );
  }
  function addRecommendedProducts() {
    poll(
      () => q("#mini-cart-form"),
      () => {
        const items = minMaxify.cart.items;
        expLog("items-=======from takeMainProductData=======", items);
        if (items.length > 0) {
          const filteredItems = items.filter((item) => {
            const key = `${item.handle}-${item.sku}`;
            const array = Object.keys(recommendedProducts);
            return array.includes(key);
          });
          if (filteredItems.length > 0) {
            const mainProductData = filteredItems[filteredItems.length - 1];
            const product = recommendedProducts[`${mainProductData.handle}-${mainProductData.sku}`];
            if (product) {
              const associatedProduct = product.associated_product;
              fetch(
                `https://www.happybrush.de/products/${associatedProduct}.json`
              ).then((response) => response.json()).then((data) => {
                addRecommendedProductsMarkup(data, product.SKU);
              }).catch((error) => {
              });
            }
          } else {
            expLog("no filteredItems-==============");
          }
        }
      }
    );
  }
  function addRecommendedProductsToCartAndActiveTag() {
    poll(
      () => q(`.${ID}-recommended-products-container`) && q(`.${ID}-recommended-products-item-title-text`) && q(`.${ID}-recommended-products-item-add-to-cart-button`),
      () => {
        const items = minMaxify.cart.items;
        const mainProductSku = q(`.${ID}-recommended-products-container`).dataset.mainProductSku;
        const mainProduct = items.find((item) => item.sku === mainProductSku);
        const associatedProductSku = q(`.${ID}-recommended-products-container`).dataset.associatedProductSku;
        const associatedProduct = items.find((item) => item.sku === associatedProductSku);
        if (associatedProduct && mainProduct) {
          q(`.${ID}-recommended-products-item-add-to-cart-button`).classList.add("active");
          updateChangeCartTag();
          addClassRecommendedProductsClassToCart();
        }
      }
    );
  }
  function addClassRecommendedProductsClassToCart() {
    poll(
      () => q(".product-item-meta__title.text--small") && q(".HAP-2-recommended-products-item-title-text") && q(`.${ID}-recommended-products-container`),
      () => {
        const items = minMaxify.cart.items;
        const mainProductSku = q(`.${ID}-recommended-products-container`).dataset.mainProductSku;
        const mainProduct = items.find((item) => item.sku === mainProductSku);
        const associatedProductSku = q(`.${ID}-recommended-products-container`).dataset.associatedProductSku;
        const associatedProduct = items.find((item) => item.sku === associatedProductSku);
        if (associatedProduct && mainProduct) {
          qq(".product-item-meta__title.text--small").forEach((item) => {
            if (q(`.${ID}-recommended-products-item-title-text`).textContent.includes(item.textContent)) {
              item.closest(".line-item").classList.add(`${ID}-recommended-product`);
              item.closest(".line-item").classList.add("hidden");
            }
            if (mainProduct?.title?.trim().includes(item.textContent)) {
              item.closest(".line-item").setAttribute("data-main-product-variant-id", mainProduct?.variant_id);
              item.closest(".line-item").setAttribute("data-associated-product-variant-id", associatedProduct?.variant_id);
            }
          });
        }
      }
    );
  }
  function removeMainAndAssociatedProductFromCart() {
    poll(
      () => q("#mini-cart-form") && q("line-item") && q(`.${ID}-recommended-products-container`),
      () => {
        const items = minMaxify.cart.items;
        const mainProductSku = q(`.${ID}-recommended-products-container`)?.dataset?.mainProductSku;
        expLog("==from removeMainAndAssociatedProductFromCart=====mainProductSku=======title=======", mainProductSku);
        const mainProduct = items.find((item) => item.sku === mainProductSku);
        const mainProductTitle = new DOMParser().parseFromString(mainProduct?.product_title.trim(), "text/html").body.textContent.replace(/\u00AD/g, "");
        ;
        const cartMainProduct = qq("line-item").find((item) => {
          const rawTitle = item.querySelector(".product-item-meta__title.text--small")?.textContent.trim();
          const cleanTitle = new DOMParser().parseFromString(rawTitle, "text/html").body.textContent.replace(/\u00AD/g, "");
          expLog("==clean comparison==", cleanTitle, mainProductTitle);
          return mainProductTitle === cleanTitle;
        });
        expLog("==from removeMainAndAssociatedProductFromCart=====cartMainProduct==============", cartMainProduct);
        const quantity = cartMainProduct?.querySelector("line-item-quantity .quantity-selector__button:first-child");
        expLog("==from removeMainAndAssociatedProductFromCart=====quantity==============", quantity);
        const associatedProductSku = q(`.${ID}-recommended-products-container`)?.dataset?.associatedProductSku;
        expLog("==from removeMainAndAssociatedProductFromCart=====associatedProductSku==============", associatedProductSku);
        const associatedProduct = items.find((item) => item.sku === associatedProductSku);
        expLog("==from removeMainAndAssociatedProductFromCart=====associatedProduct==============", associatedProduct);
        if (mainProduct?.quantity === 1 && associatedProduct) {
          expLog("==from removeMainAndAssociatedProductFromCart=====qauantity is 1=====");
          const mainProductVariantId = mainProduct?.id;
          const associatedProductVariantId = associatedProduct?.id;
          expLog("==from removeMainAndAssociatedProductFromCart=====mainProductVariantId and associatedProductVariantId==============", mainProductVariantId, associatedProductVariantId);
          quantity.addEventListener("click", (e) => {
            expLog("=======e==============", e);
            e.preventDefault();
            e.stopPropagation();
            expLog("====from removeMainAndAssociatedProductFromCart=====quantity.click()==============");
            fetch("https://www.happybrush.de/cart/update.js", {
              method: "POST",
              credentials: "include",
              mode: "cors",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates: {
                  [`${mainProductVariantId}`]: 0,
                  // Remove line 1
                  [`${associatedProductVariantId}`]: 0
                  // Remove line 2
                },
                sections: ["mini-cart"]
              })
            }).then((response) => {
              expLog("=======data==============", response);
              cartRefresh();
            }).catch((error) => {
              expLog("=======error==============", error);
            });
          });
        }
      },
      true
    );
  }
  function getProgessBar() {
    poll(
      () => q("free-shipping-bar"),
      () => {
        const progressBar = q("free-shipping-bar");
        let progress = parseFloat(progressBar.style.getPropertyValue("--progress").replace("%", ""));
        expLog("=======progress==============", progress);
        if (progress > 80 && progress < 90) {
          progressBar.style.setProperty("--progress", `${progress + 10}%`);
        }
        expLog("=======progressBar=========after change=====", progressBar);
      }
    );
  }
  function handleMutation() {
    poll(
      () => q("cart-drawer"),
      (base) => {
        const targetNode = base;
        const config = { childList: true };
        const callback = (mutationsList) => {
          expLog("MUTATION OBSERVED");
          expLog("cart items-==============", minMaxify.cart.items);
          changeMiniCart();
          changeGiftCart();
          addRecommendedProducts();
          addRecommendedProductsToCart();
          addRecommendedProductsToCartAndActiveTag();
          textContainerActive();
          addClassRecommendedProductsClassToCart();
          removeMainAndAssociatedProductFromCart();
          getProgessBar();
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }
    );
  }
  function mainJS() {
    testInfo("Redesigned mini-cart sitewide");
    changeMiniCart();
    changeGiftCart();
    addRecommendedProducts();
    addRecommendedProductsToCart();
    addRecommendedProductsToCartAndActiveTag();
    textContainerActive();
    handleMutation();
    removeMainAndAssociatedProductFromCart();
    getProgessBar();
    removeOnlyUpsellProduct();
  }
  mainJS();
})();

//# sourceURL=ABtest/HAP-2_1.js